<form ngNativeValidate #loginForm="ngForm" class="login-form section container-fluid center" (submit)="login(); loginForm.reset();">
  <br />
  <h2 class="white-text">
    Matrix Tools
  </h2>
  <br />
  <div>
    <img class="icon" src="/images/icons/seo-dashboard.png" alt="Custom Web Tools" title="Matrix Tools" />
  </div>
  <br />
  <input type="text" class="default form-control login-email" placeholder="Email Address" [(ngModel)]="email" name="email" required autofocus />
  <br />
  <input type="password" class="default form-control login-password" placeholder="Password" [(ngModel)]="password" name="password" required />
  <br />
  <br />
  <button type="submit" class="red-pill margin-bottom animated fadeInUp" title="Sign In to Matrix Tools">
    Sign In
  </button>
  <br />
  <a href="//jeb" title="Digital Marketing">Forgot password?</a>
  <br />
</form>
<br />
<div class="text-center">
  <!--//jebjebjeb go to sign up page!-->
  <button type="submit" class="blue-pill animated fadeInUp" title="Sign In to Matrix Tools">
    Create a NEW Account
  </button>  
</div>
